/* =========================================================
   Dolcet — scripts propios (vanilla, sin librerías)
   ========================================================= */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function mostrarTodo() {
    var todos = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    for (var i = 0; i < todos.length; i++) todos[i].classList.add('mt-visible');
  }

  /* ---- Animaciones de entrada al hacer scroll ---- */
  function initReveals() {
    var items = document.querySelectorAll('.mt-reveal:not(.mt-visible)');
    if (!items.length) return;

    if (reduceMotion || !('IntersectionObserver' in window)) {
      mostrarTodo();
      return;
    }

    // threshold 0 + un margen inferior pequeño en px: con threshold 0.12 un
    // elemento más alto que la ventana (o una ventana muy baja) nunca llega a
    // ese porcentaje y se quedaría invisible para siempre.
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });

    for (var j = 0; j < items.length; j++) observer.observe(items[j]);

    // Red de seguridad: pase lo que pase, a los 3 s todo se ve.
    setTimeout(mostrarTodo, 3000);
  }

  /* ---- FAQ desplegable ---- */
  function initFaq() {
    var buttons = document.querySelectorAll('.mt-faq__q');
    if (!buttons.length) return;

    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        if (btn.dataset.mtBound) return;
        btn.dataset.mtBound = '1';

        btn.addEventListener('click', function () {
          var item = btn.closest('.mt-faq__item');
          var panel = item.querySelector('.mt-faq__a');
          var isOpen = item.classList.contains('mt-open');

          var siblings = item.parentElement.querySelectorAll('.mt-faq__item.mt-open');
          for (var k = 0; k < siblings.length; k++) {
            siblings[k].classList.remove('mt-open');
            siblings[k].querySelector('.mt-faq__a').style.maxHeight = '0px';
            siblings[k].querySelector('.mt-faq__q').setAttribute('aria-expanded', 'false');
          }

          if (!isOpen) {
            item.classList.add('mt-open');
            panel.style.maxHeight = panel.scrollHeight + 'px';
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      })(buttons[i]);
    }

    // Reajusta la altura si cambia el ancho (el texto refluye)
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var open = document.querySelectorAll('.mt-faq__item.mt-open .mt-faq__a');
        for (var k = 0; k < open.length; k++) open[k].style.maxHeight = open[k].scrollHeight + 'px';
      }, 150);
    });
  }

  /* ---- Galería de la página de producto ---- */
  function initGaleria() {
    var galerias = document.querySelectorAll('[data-mt-galeria]');
    if (!galerias.length) return;

    for (var i = 0; i < galerias.length; i++) {
      (function (galeria) {
        if (galeria.dataset.mtBound) return;
        galeria.dataset.mtBound = '1';

        var main = galeria.querySelector('[data-mt-galeria-main]');
        var thumbs = galeria.querySelectorAll('[data-mt-galeria-thumb]');
        if (!main || !thumbs.length) return;

        for (var j = 0; j < thumbs.length; j++) {
          (function (thumb) {
            thumb.addEventListener('click', function () {
              var src = thumb.getAttribute('data-src');
              var alt = thumb.getAttribute('data-alt') || '';
              if (!src) return;
              main.setAttribute('src', src);
              main.setAttribute('alt', alt);
              for (var k = 0; k < thumbs.length; k++) thumbs[k].classList.remove('mt-active');
              thumb.classList.add('mt-active');
            });
          })(thumbs[j]);
        }
      })(galerias[i]);
    }
  }

  /* ---- Colores por par en la ficha de producto ---- */
  function initColoresProducto() {
    var cajas = document.querySelectorAll('[data-mt-colores-producto]');
    if (!cajas.length) return;

    for (var i = 0; i < cajas.length; i++) {
      (function (caja) {
        if (caja.dataset.mtBound) return;
        caja.dataset.mtBound = '1';

        var raiz = caja.closest('[data-mt-variantes]');
        var unidades = (caja.getAttribute('data-unidades') || '1')
          .split('\n').map(function (x) { return parseInt(x.trim(), 10) || 1; });
        var textoPar = caja.getAttribute('data-texto-par') || 'Pair [n] colour';
        var textoUno = caja.getAttribute('data-texto-uno') || 'Colour';
        var filas = caja.querySelectorAll('[data-mt-color-grupo]');

        // El color es una propiedad del carrito, no una variante, así que
        // Shopify no cambia la foto solo: hay que emparejarla a mano con la
        // imagen de la galería cuyo nombre lleva ese color.
        function mostrarFotoDelColor(color) {
          var galeria = document.querySelector('[data-mt-galeria]');
          if (!galeria || !color) return;
          var clave = color.toLowerCase().replace(/[^a-z0-9]/g, '');
          var thumbs = galeria.querySelectorAll('[data-mt-galeria-thumb]');
          for (var t = 0; t < thumbs.length; t++) {
            var src = (thumbs[t].getAttribute('data-src') || '').toLowerCase();
            if (src.indexOf('mt-color-' + clave) !== -1) { thumbs[t].click(); return; }
          }
        }

        // clic en un color
        for (var f = 0; f < filas.length; f++) {
          (function (fila) {
            var campo = fila.querySelector('[data-mt-color-valor]');
            var botones = fila.querySelectorAll('.mt-pack__color-btn');
            var esPrimera = fila.getAttribute('data-indice') === '1';
            for (var b = 0; b < botones.length; b++) {
              (function (btn) {
                btn.addEventListener('click', function () {
                  for (var k = 0; k < botones.length; k++) botones[k].classList.remove('mt-active');
                  btn.classList.add('mt-active');
                  var color = btn.getAttribute('data-color');
                  if (campo) campo.value = color;
                  // Solo el primer par manda sobre la foto: con tres pares de
                  // colores distintos no hay una única imagen que los muestre.
                  if (esPrimera) mostrarFotoDelColor(color);
                });
              })(botones[b]);
            }
          })(filas[f]);
        }

        // cuántos selectores mostrar según el pack elegido
        function ajustar() {
          var pos = 0;
          if (raiz) {
            var grupoPack = raiz.querySelector('[data-mt-opt-group]');
            if (grupoPack) {
              var opciones = grupoPack.querySelectorAll('.mt-compra__opt-btn');
              for (var o = 0; o < opciones.length; o++) {
                if (opciones[o].classList.contains('mt-active')) { pos = o; break; }
              }
            }
          }
          var n = unidades[pos] || 1;
          for (var f2 = 0; f2 < filas.length; f2++) {
            var fila = filas[f2];
            var idx = parseInt(fila.getAttribute('data-indice'), 10);
            var visible = idx <= n;
            fila.hidden = !visible;
            var campo = fila.querySelector('[data-mt-color-valor]');
            var etiqueta = fila.querySelector('[data-mt-color-etiqueta]');
            // Un campo deshabilitado no se envía: así el pedido solo lleva
            // los pares que el cliente realmente ha comprado.
            if (campo) {
              campo.disabled = !visible;
              campo.name = n > 1 ? 'properties[' + textoPar.replace('[n]', idx) + ']' : 'properties[' + textoUno + ']';
            }
            if (etiqueta) etiqueta.textContent = n > 1 ? textoPar.replace('[n]', idx) : textoUno;
          }
        }

        if (raiz) {
          var btnsPack = raiz.querySelectorAll('.mt-compra__opt-btn');
          for (var p = 0; p < btnsPack.length; p++) {
            btnsPack[p].addEventListener('click', function () { setTimeout(ajustar, 0); });
          }
        }
        ajustar();
      })(cajas[i]);
    }
  }

  /* ---- Selector de variantes ---- */
  function initVariantes() {
    var forms = document.querySelectorAll('[data-mt-variantes]');
    if (!forms.length) return;

    for (var i = 0; i < forms.length; i++) {
      (function (root) {
        if (root.dataset.mtBound) return;
        root.dataset.mtBound = '1';

        var dataEl = root.querySelector('[data-mt-variant-data]');
        if (!dataEl) return;

        var variants;
        try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
        if (!variants || !variants.length) return;

        var idInput = root.querySelector('[data-mt-variant-id]');
        var priceEl = root.querySelector('[data-mt-price]');
        var comparEl = root.querySelector('[data-mt-compare]');
        var submitBtn = root.querySelector('[data-mt-submit]');
        var stockEl = root.querySelector('[data-mt-stock]');
        var moneyFormat = root.getAttribute('data-money-format') || '${{amount}}';

        function formatMoney(cents) {
          var amount = (cents / 100).toFixed(2);
          return moneyFormat.replace(/\{\{\s*amount[^}]*\}\}/, amount);
        }

        function selectedOptions() {
          var groups = root.querySelectorAll('[data-mt-opt-group]');
          var values = [];
          for (var g = 0; g < groups.length; g++) {
            var active = groups[g].querySelector('.mt-compra__opt-btn.mt-active');
            values.push(active ? active.getAttribute('data-value') : null);
          }
          return values;
        }

        function update() {
          var chosen = selectedOptions();
          var match = null;
          for (var v = 0; v < variants.length; v++) {
            var ok = true;
            for (var o = 0; o < chosen.length; o++) {
              if (chosen[o] !== null && variants[v].options[o] !== chosen[o]) { ok = false; break; }
            }
            if (ok) { match = variants[v]; break; }
          }
          if (!match) return;

          if (idInput) idInput.value = match.id;
          if (priceEl) priceEl.textContent = formatMoney(match.price);
          if (comparEl) {
            if (match.compare_at_price && match.compare_at_price > match.price) {
              comparEl.textContent = formatMoney(match.compare_at_price);
              comparEl.style.display = '';
            } else {
              comparEl.style.display = 'none';
            }
          }
          if (submitBtn) {
            submitBtn.disabled = !match.available;
            submitBtn.textContent = match.available
              ? submitBtn.getAttribute('data-text-available')
              : submitBtn.getAttribute('data-text-soldout');
          }
          if (stockEl) stockEl.style.display = match.available ? '' : 'none';

          if (window.history && window.history.replaceState) {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', match.id);
            window.history.replaceState({}, '', url.toString());
          }
        }

        var btns = root.querySelectorAll('.mt-compra__opt-btn');
        for (var b = 0; b < btns.length; b++) {
          (function (btn) {
            btn.addEventListener('click', function () {
              var group = btn.closest('[data-mt-opt-group]');
              var peers = group.querySelectorAll('.mt-compra__opt-btn');
              for (var p = 0; p < peers.length; p++) peers[p].classList.remove('mt-active');
              btn.classList.add('mt-active');
              update();
            });
          })(btns[b]);
        }
      })(forms[i]);
    }
  }

  /* ---- Packs con selector de color ---- */
  function initPacks() {
    var cajas = document.querySelectorAll('[data-mt-packs]');
    if (!cajas.length) return;

    for (var i = 0; i < cajas.length; i++) {
      (function (caja) {
        if (caja.dataset.mtBound) return;
        caja.dataset.mtBound = '1';

        var datos = caja.querySelector('[data-mt-packs-data]');
        if (!datos) return;
        var variantes;
        try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
        if (!variantes || !variantes.length) return;

        var formato = caja.getAttribute('data-money-format') || '${{amount}}';
        var tarjetas = caja.querySelectorAll('[data-mt-pack]');

        function dinero(centimos) {
          return formato.replace(/\{\{\s*amount[^}]*\}\}/, (centimos / 100).toFixed(2));
        }

        // El color de cada par es una propiedad del carrito, no una variante.
        var grupos = caja.querySelectorAll('[data-mt-color-grupo]');
        for (var g = 0; g < grupos.length; g++) {
          (function (grupo) {
            var campo = grupo.querySelector('[data-mt-color-valor]');
            var botones = grupo.querySelectorAll('.mt-pack__color-btn');
            for (var b = 0; b < botones.length; b++) {
              (function (btn) {
                btn.addEventListener('click', function () {
                  for (var k = 0; k < botones.length; k++) botones[k].classList.remove('mt-active');
                  btn.classList.add('mt-active');
                  if (campo) campo.value = btn.getAttribute('data-color');
                });
              })(botones[b]);
            }
          })(grupos[g]);
        }

        function pintar() {
          for (var t = 0; t < tarjetas.length; t++) {
            var tarjeta = tarjetas[t];
            var pack = tarjeta.getAttribute('data-mt-pack');
            var unidades = parseInt(tarjeta.getAttribute('data-mt-unidades'), 10) || 1;

            var match = null;
            for (var v = 0; v < variantes.length; v++) {
              var o = variantes[v].opciones || [];
              if (o.indexOf(pack) === -1) continue;
              match = variantes[v];
              break;
            }
            if (!match) continue;

            var campoId = tarjeta.querySelector('[data-mt-pack-id]');
            var elPrecio = tarjeta.querySelector('[data-mt-pack-precio]');
            var elAntes = tarjeta.querySelector('[data-mt-pack-antes]');
            var elUnidad = tarjeta.querySelector('[data-mt-pack-unidad]');
            var elAhorro = tarjeta.querySelector('[data-mt-pack-ahorro]');
            var elDescuento = tarjeta.querySelector('[data-mt-pack-descuento]');
            var boton = tarjeta.querySelector('[data-mt-pack-boton]');

            if (campoId) campoId.value = match.id;
            if (elPrecio) elPrecio.textContent = dinero(match.precio);
            if (elUnidad) elUnidad.textContent = dinero(Math.round(match.precio / unidades));

            var hayAntes = match.antes && match.antes > match.precio;
            if (elAntes) {
              elAntes.textContent = hayAntes ? dinero(match.antes) : '';
              elAntes.style.display = hayAntes ? '' : 'none';
            }
            var pct = hayAntes ? Math.round(((match.antes - match.precio) * 100) / match.antes) : 0;
            if (elAhorro) {
              if (hayAntes) {
                elAhorro.textContent = (elAhorro.getAttribute('data-texto') || 'You save') + ' ' + dinero(match.antes - match.precio);
                elAhorro.style.display = '';
              } else {
                elAhorro.style.display = 'none';
              }
            }
            if (elDescuento) {
              if (hayAntes && pct > 0) {
                elDescuento.textContent = (elDescuento.getAttribute('data-texto') || 'Save [n]%').replace('[n]', pct);
                elDescuento.hidden = false;
              } else {
                elDescuento.hidden = true;
              }
            }
            if (boton) {
              boton.disabled = !match.disponible;
              boton.textContent = match.disponible
                ? boton.getAttribute('data-texto-disponible')
                : boton.getAttribute('data-texto-agotado');
            }
          }
        }

        // "Ir directo al pago": se añade al carrito por detrás y se salta
        // la página de carrito, que es un clic de más donde se pierde gente.
        if (caja.getAttribute('data-accion') === 'checkout') {
          var formularios = caja.querySelectorAll('form');
          for (var n = 0; n < formularios.length; n++) {
            (function (form) {
              form.addEventListener('submit', function (ev) {
                ev.preventDefault();
                var boton = form.querySelector('[data-mt-pack-boton]');
                if (boton) {
                  if (boton.disabled) return;
                  boton.disabled = true;
                  boton.textContent = boton.getAttribute('data-texto-cargando') || '…';
                }
                fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
                  .then(function (r) {
                    if (!r.ok) throw new Error('add');
                    window.location.href = '/checkout';
                  })
                  .catch(function () {
                    // Si algo falla, se envía el formulario de toda la vida.
                    if (boton) {
                      boton.disabled = false;
                      boton.textContent = boton.getAttribute('data-texto-disponible');
                    }
                    form.submit();
                  });
              });
            })(formularios[n]);
          }
        }

        pintar();
      })(cajas[i]);
    }
  }

  /* ---- Carrusel de "para quién es" ---- */
  function initCarrusel() {
    var carruseles = document.querySelectorAll('[data-mt-carrusel]');
    if (!carruseles.length) return;

    for (var i = 0; i < carruseles.length; i++) {
      (function (carrusel) {
        if (carrusel.dataset.mtBound) return;
        carrusel.dataset.mtBound = '1';

        var slides = carrusel.querySelectorAll('[data-mt-slide]');
        if (slides.length < 2) return;
        var puntos = carrusel.querySelectorAll('[data-mt-punto]');
        var seccion = carrusel.closest('.mt-paraquien');
        var perfiles = seccion ? seccion.querySelectorAll('[data-mt-perfil]') : [];
        var intervalo = parseInt(carrusel.getAttribute('data-intervalo'), 10) || 5000;
        var actual = 0;
        var reloj = null;

        function mostrar(n) {
          actual = (n + slides.length) % slides.length;
          for (var s = 0; s < slides.length; s++) slides[s].classList.toggle('mt-active', s === actual);
          for (var p = 0; p < puntos.length; p++) puntos[p].classList.toggle('mt-active', p === actual);
          for (var f = 0; f < perfiles.length; f++) perfiles[f].classList.toggle('mt-active', f === actual);
        }

        function arrancar() {
          if (reduceMotion) return;
          parar();
          reloj = setInterval(function () { mostrar(actual + 1); }, intervalo);
        }
        function parar() { if (reloj) { clearInterval(reloj); reloj = null; } }

        for (var p2 = 0; p2 < puntos.length; p2++) {
          (function (btn, idx) {
            btn.addEventListener('click', function () { mostrar(idx); arrancar(); });
          })(puntos[p2], p2);
        }
        // Pulsar un perfil de la lista enseña su foto.
        for (var f2 = 0; f2 < perfiles.length; f2++) {
          (function (fila, idx) {
            fila.addEventListener('click', function () { mostrar(idx); arrancar(); });
          })(perfiles[f2], f2);
        }

        carrusel.addEventListener('mouseenter', parar);
        carrusel.addEventListener('mouseleave', arrancar);

        // Solo corre mientras se ve: ahorra batería en móvil.
        if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entradas) {
            entradas.forEach(function (e) { e.isIntersecting ? arrancar() : parar(); });
          }, { threshold: 0.2 }).observe(carrusel);
        } else {
          arrancar();
        }

        mostrar(0);
      })(carruseles[i]);
    }
  }

  /* ---- Parallax suave del banner de apertura ---- */
  function initParallax() {
    if (reduceMotion) return;
    var banners = document.querySelectorAll('[data-mt-parallax]');
    if (!banners.length) return;

    var activos = [];
    for (var i = 0; i < banners.length; i++) {
      var fondo = banners[i].querySelector('.mt-herob__bg');
      if (fondo) activos.push({ seccion: banners[i], fondo: fondo });
    }
    if (!activos.length) return;

    var pendiente = false;
    function pintar() {
      pendiente = false;
      // En móvil la foto va apilada sobre el texto: moverla la recortaría.
      if (window.innerWidth <= 860) {
        for (var k = 0; k < activos.length; k++) activos[k].fondo.style.transform = '';
        return;
      }
      var alto = window.innerHeight;
      for (var j = 0; j < activos.length; j++) {
        var caja = activos[j].seccion.getBoundingClientRect();
        if (caja.bottom < 0 || caja.top > alto) continue;
        // -1 (sección justo debajo de la ventana) a 1 (justo encima)
        var avance = (caja.top + caja.height / 2 - alto / 2) / (alto / 2 + caja.height / 2);
        activos[j].fondo.style.transform = 'translate3d(0,' + (avance * 26).toFixed(2) + 'px,0)';
      }
    }
    function alHacerScroll() {
      if (pendiente) return;
      pendiente = true;
      window.requestAnimationFrame(pintar);
    }
    window.addEventListener('scroll', alHacerScroll, { passive: true });
    window.addEventListener('resize', alHacerScroll, { passive: true });
    pintar();
  }

  /* ---- Arranque ---- */
  function init() {
    initReveals();
    initParallax();
    initCarrusel();
    initPacks();
    initFaq();
    initGaleria();
    initVariantes();
    initColoresProducto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // El editor de Shopify recarga secciones sueltas: vuelve a enganchar todo.
  document.addEventListener('shopify:section:load', init);
})();
